<section
  class="cx-page-section container"
  *ngIf="!(isLoading$ | async); else loading"
>
  <div
    *cxFeature="'!a11yRemoveStatusLoadedRole'"
    role="status"
    [attr.aria-label]="'common.loaded' | cxTranslate"
  ></div>
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="cx-section">
        <!-- TODO: (CXSPA-5953) Remove feature flags next major -->
        <cx-form-required-legend />
        <form (ngSubmit)="submitForm()" [formGroup]="registerForm">
          <div class="form-group">
            <label>
              <span class="label-content">{{
                'register.titleOptional' | cxTranslate
              }}</span>
              <ng-select
                [clearable]="false"
                [items]="titles$ | async"
                [placeholder]="'register.selectTitle' | cxTranslate"
                [searchable]="false"
                bindLabel="name"
                bindValue="code"
                formControlName="titleCode"
                id="title-select"
                [cxNgSelectA11y]="{}"
              >
              </ng-select>
            </label>
          </div>

          <div class="form-group">
            <label>
              <span class="label-content"
                >{{ 'register.firstName.label' | cxTranslate }}
                <cx-form-required-asterisks />
              </span>
              <input
                required="true"
                class="form-control"
                type="text"
                name="firstname"
                placeholder="{{
                  'register.firstName.placeholder' | cxTranslate
                }}"
                formControlName="firstName"
                [attr.aria-invalid]="
                  registerForm.get('firstName')?.touched &&
                  registerForm.get('firstName')?.invalid
                "
                [attr.aria-errormessage]="'firstNameError'"
              />

              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
              <cx-form-errors
                *cxFeature="'formErrorsDescriptiveMessages'"
                id="firstNameError"
                [translationParams]="{
                  label: 'register.firstName.label' | cxTranslate,
                }"
                [control]="registerForm.get('firstName')"
              ></cx-form-errors>

              <cx-form-errors
                *cxFeature="'!formErrorsDescriptiveMessages'"
                [control]="registerForm.get('firstName')"
              ></cx-form-errors>
            </label>
          </div>

          <div class="form-group">
            <label>
              <span class="label-content"
                >{{ 'register.lastName.label' | cxTranslate }}
                <cx-form-required-asterisks />
              </span>
              <input
                required="true"
                class="form-control"
                type="text"
                name="lastname"
                placeholder="{{
                  'register.lastName.placeholder' | cxTranslate
                }}"
                formControlName="lastName"
                [attr.aria-invalid]="
                  registerForm.get('lastName')?.touched &&
                  registerForm.get('lastName')?.invalid
                "
                [attr.aria-errormessage]="'lastNameError'"
              />

              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
              <cx-form-errors
                *cxFeature="'formErrorsDescriptiveMessages'"
                id="lastNameError"
                [translationParams]="{
                  label: 'register.lastName.label' | cxTranslate,
                }"
                [control]="registerForm.get('lastName')"
              ></cx-form-errors>

              <cx-form-errors
                *cxFeature="'!formErrorsDescriptiveMessages'"
                [control]="registerForm.get('lastName')"
              ></cx-form-errors>
            </label>
          </div>

          <div class="form-group">
            <label>
              <span class="label-content"
                >{{ 'register.emailAddress.label' | cxTranslate }}
                <cx-form-required-asterisks />
              </span>
              <input
                required="true"
                class="form-control"
                type="email"
                name="email"
                placeholder="{{
                  'register.emailAddress.placeholder' | cxTranslate
                }}"
                formControlName="email"
                [attr.aria-invalid]="
                  registerForm.get('email')?.touched &&
                  registerForm.get('email')?.invalid
                "
                [attr.aria-errormessage]="'emailError'"
              />

              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
              <cx-form-errors
                *cxFeature="'formErrorsDescriptiveMessages'"
                id="emailError"
                [translationParams]="{
                  label: 'register.emailAddress.label' | cxTranslate,
                }"
                [control]="registerForm.get('email')"
              ></cx-form-errors>

              <cx-form-errors
                *cxFeature="'!formErrorsDescriptiveMessages'"
                [control]="registerForm.get('email')"
              ></cx-form-errors>
            </label>
          </div>

          <div class="form-group">
            <label>
              <span class="label-content"
                >{{ 'register.password.label' | cxTranslate }}
                <cx-form-required-asterisks />
              </span>
              <input
                required="true"
                class="form-control"
                type="password"
                name="password"
                placeholder="{{
                  'register.password.placeholder' | cxTranslate
                }}"
                formControlName="password"
                [attr.aria-label]="
                  'register.password.placeholder' | cxTranslate
                "
                aria-describedby="password-input-hint"
                cxPasswordVisibilitySwitch
              />
              <p class="input-hint" id="password-input-hint">
                {{ 'register.passwordMinRequirements' | cxTranslate }}
              </p>

              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
              <cx-form-errors
                *cxFeature="'formErrorsDescriptiveMessages'"
                [translationParams]="{
                  label: 'register.password.label' | cxTranslate,
                }"
                [control]="registerForm.get('password')"
              ></cx-form-errors>

              <cx-form-errors
                *cxFeature="'!formErrorsDescriptiveMessages'"
                [control]="registerForm.get('password')"
              ></cx-form-errors>
            </label>
          </div>

          <div class="form-group">
            <label>
              <span class="label-content"
                >{{ 'register.confirmPassword.label' | cxTranslate }}
                <cx-form-required-asterisks />
              </span>
              <input
                required="true"
                class="form-control"
                type="password"
                name="confirmpassword"
                placeholder="{{
                  'register.confirmPassword.placeholder' | cxTranslate
                }}"
                formControlName="passwordconf"
                [attr.aria-label]="
                  'register.confirmPassword.placeholder' | cxTranslate
                "
                [attr.aria-invalid]="
                  registerForm.get('passwordconf')?.touched &&
                  registerForm.get('passwordconf')?.invalid
                "
                [attr.aria-errormessage]="'passwordconfError'"
                cxPasswordVisibilitySwitch
              />

              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
              <cx-form-errors
                *cxFeature="'formErrorsDescriptiveMessages'"
                id="passwordconfError"
                [translationParams]="{
                  label: 'register.confirmPassword.label' | cxTranslate,
                }"
                [control]="registerForm.get('passwordconf')"
              ></cx-form-errors>

              <cx-form-errors
                *cxFeature="'!formErrorsDescriptiveMessages'"
                [control]="registerForm.get('passwordconf')"
              ></cx-form-errors>
            </label>
          </div>

          <div class="form-group">
            <div class="form-check">
              <ng-container
                *ngIf="anonymousConsent$ | async as anonymousConsent"
              >
                <label *ngIf="anonymousConsent.template">
                  <input
                    type="checkbox"
                    name="newsletter"
                    class="form-check-input"
                    formControlName="newsletter"
                    [checked]="isConsentGiven(anonymousConsent.consent)"
                  />
                  <span class="form-check-label">
                    {{ anonymousConsent.template }}
                  </span>
                </label>
              </ng-container>
            </div>
          </div>

          <div
            formArrayName="additionalConsents"
            class="form-group"
            *ngIf="additionalRegistrationConsents as consents"
          >
            <div
              class="form-check"
              *ngFor="let control of additionalConsents.controls; let i = index"
              [formGroupName]="i"
            >
              <div *ngIf="consents[i]?.template?.id as id">
                <label>
                  <input
                    type="checkbox"
                    [required]="consents[i].required"
                    [name]="id"
                    (change)="updateAdditionalConsents($any($event), i)"
                    formControlName="isConsentGranted"
                  />
                  <span class="form-check-label">
                    {{ consents[i].template.description }}
                    <ng-container *ngIf="consents[i].required">
                      <cx-form-required-asterisks />
                    </ng-container>
                  </span>
                  <cx-form-errors
                    [control]="control.get('isConsentGranted')"
                  ></cx-form-errors>
                </label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-check">
              <label>
                <input
                  required="true"
                  type="checkbox"
                  name="termsandconditions"
                  formControlName="termsandconditions"
                  [attr.aria-invalid]="
                    registerForm.get('termsandconditions')?.touched &&
                    registerForm.get('termsandconditions')?.invalid
                  "
                  [attr.aria-errormessage]="'termsandconditionsError'"
                />
                <span class="form-check-label">
                  {{ 'register.confirmThatRead' | cxTranslate }}
                  <a
                    [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ 'register.termsAndConditions' | cxTranslate }}
                  </a>
                  <cx-form-required-asterisks />
                </span>

                <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
                <cx-form-errors
                  *cxFeature="'formErrorsDescriptiveMessages'"
                  id="termsandconditionsError"
                  [translationParams]="{
                    label: 'register.termsAndConditions' | cxTranslate,
                  }"
                  [control]="registerForm.get('termsandconditions')"
                ></cx-form-errors>

                <cx-form-errors
                  *cxFeature="'!formErrorsDescriptiveMessages'"
                  [control]="registerForm.get('termsandconditions')"
                ></cx-form-errors>
              </label>
            </div>
          </div>
          <cx-captcha (confirmed)="captchaConfirmed()"></cx-captcha>
          <cx-form-errors
            [control]="registerForm.get('captcha')"
          ></cx-form-errors>
          <button type="submit" class="btn btn-block btn-primary">
            {{ 'register.register' | cxTranslate }}
          </button>
          <a
            class="cx-login-link btn-link"
            [routerLink]="{ cxRoute: 'login' } | cxUrl"
            >{{ 'register.signIn' | cxTranslate }}</a
          >
        </form>
      </div>
    </div>
  </div>
</section>

<ng-template #loading>
  <div class="cx-spinner"><cx-spinner></cx-spinner></div>
</ng-template>
